import { Route, Routes } from "react-router-dom";
import RouteAccessError from "pages/RouteAccessError";
import PermissionRoute from "components/route/PermissionRoute";
import { PERMISSIONS } from "config/permissions";
import MaintenanceHistoryMonitoring from "pages/monitoring/maintenance-history";
import MaintenanceHistoryViewMonitoring from "pages/monitoring/maintenance-history-view";

export default function MonitoringMaintenanceHistoryRoutes(props) {

    return (
        <Routes>
            <Route path="/*">
                <Route path="/*" element={ 
                    <PermissionRoute
                        permission={PERMISSIONS.FRONT_READ}
                    >
                        <MaintenanceHistoryMonitoring />
                    </PermissionRoute>
                }/>
                
                <Route path=":id" element={
                    <PermissionRoute
                        permission={PERMISSIONS.FRONT_READ}
                    >
                        <MaintenanceHistoryViewMonitoring />
                    </PermissionRoute>
                }/>
               
                <Route path="*" element={ <RouteAccessError /> }/>
            </Route>
        </Routes>
    );
}